
/* Function ========================================================= */
export function dateToYMD(date) {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
};


export function ymdToDate(strDate) {
    // 빈 문자열 또는 잘못된 형식 검사
    if (!strDate || typeof strDate !== "string" || strDate.length !== 8) {
        return ""; // 빈 문자열 반환
    }

    try {
        return new Date(
            parseInt(strDate.slice(0, 4)), // 연도
            parseInt(strDate.slice(4, 6)) - 1, // 월 (0부터 시작하므로 -1)
            parseInt(strDate.slice(6, 8)) // 일
        );
    } catch (error) {
        console.error("날짜 변환 중 오류 발생:", error);
        return "";
    }

};

/* calculate Function ========================================================= */
export function calcEGFR(creatinine, age, sex) {


    // 입력값이 하나라도 없거나 공백일 경우 빈 문자열 반환
    if (!creatinine?.trim() || !age?.trim() || !sex?.trim()) {
        return "";
    }

    // 성별이 'M' 또는 'F'가 아닐 경우 빈 문자열 반환
    if (!["M", "F"].includes(sex)) {
        return "";
    }

    // 숫자로 변환 시도
    let creatinineNum = parseFloat(creatinine);
    let ageNum = parseInt(age, 10);

    // 변환된 값이 숫자가 아닐 경우 빈 문자열 반환
    if (isNaN(creatinineNum) || isNaN(ageNum) || creatinineNum <= 0 || ageNum <= 0) {
        return "";
    }

    let eGfr = 175 * Math.pow(creatinineNum, -1.154) * Math.pow(ageNum, -0.203);

    if (sex === "F") {
        eGfr *= 0.742;
    }

    // 결과값이 Infinity 또는 NaN이면 빈 문자열 반환
    if (!isFinite(eGfr)) {
        return "";
    }

    return String(eGfr.toFixed(2));
}


export function calcQcaDs(MLD, RVD) {

    // 입력값이 문자열(string)인지 확인
    if (typeof MLD !== "string" || typeof RVD !== "string") {
        return "";
    }

    // 입력값이 없거나 공백일 경우 빈 문자열 반환
    if (!MLD.trim() || !RVD.trim()) {
        return "";
    }

    // 숫자로 변환
    let MLDNum = Number(MLD);
    let RVDNum = Number(RVD);

    // 변환된 값이 숫자가 아닐 경우 빈 문자열 반환
    if (isNaN(MLDNum) || isNaN(RVDNum) || MLDNum <= 0 || RVDNum <= 0) {
        return "";
    }
    // 잔여 협착률(DS%) 계산
    let DS = (1 - MLDNum / RVDNum) * 100;
    // 결과값이 Infinity 또는 NaN이면 빈 문자열 반환
    if (!isFinite(DS)) {
        return "";
    }
    // 결과 반환 (소수점 2자리)
    return String(DS.toFixed(2));
}

//날짜계산 : 기준일자, 계산일자 return "YYYYMMDD"
export function addDaysToDate(baseDate, adjustment = 0) {
    // 입력값 검증 (null, undefined, 빈 문자열, 형식 오류)
    if (!baseDate || baseDate.trim() === "" || !/^\d{8}$/.test(baseDate)) {
        return null; // 올바르지 않은 입력값이면 null 반환
    }

    // 날짜 변환 함수
    function parseDate(yyyymmdd) {
        const year = parseInt(yyyymmdd.substring(0, 4), 10);
        const month = parseInt(yyyymmdd.substring(4, 6), 10) - 1;
        const day = parseInt(yyyymmdd.substring(6, 8), 10);
        return new Date(year, month, day);
    }

    // 날짜 포맷 변환 함수
    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}${month}${day}`;
    }

    const base = parseDate(baseDate);

    // 변환된 날짜가 올바른지 검증
    if (isNaN(base.getTime())) {
        return null; // 날짜 변환 실패 시 null 반환
    }

    // 날짜 조정
    base.setDate(base.getDate() + adjustment);

    return formatDate(base); // 조정된 날짜를 'yyyymmdd' 형식으로 반환
}


//날짜계산 : 기준일자, 계산일자 return 차이일수
export function getDaysBetween(baseDate, targetDate) {
    if (!baseDate || !targetDate) {
        return null; // 입력이 부족하면 null 반환
    }

    if (!/^\d{8}$/.test(baseDate) || !/^\d{8}$/.test(targetDate)) {
        return null; // 올바른 날짜 형식이 아니면 null 반환
    }

    function parseDate(yyyymmdd) {
        const year = parseInt(yyyymmdd.substring(0, 4), 10);
        const month = parseInt(yyyymmdd.substring(4, 6), 10) - 1;
        const day = parseInt(yyyymmdd.substring(6, 8), 10);
        return new Date(year, month, day);
    }

    const base = parseDate(baseDate);
    const target = parseDate(targetDate);

    if (isNaN(base.getTime()) || isNaN(target.getTime())) {
        return null; // 날짜 변환 실패 시 null 반환
    }

    const diffTime = target.getTime() - base.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return isFinite(diffDays) && !isNaN(diffDays) ? diffDays : null;
}

